// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'

// import vuetify from '@/plugins/vuetify' // path to vuetify export
// import './plugins/vuetify'

/**
 *  Module Vuetify qui permet la création de nos éléments HTML
 *  gère les actions avec VueJS et le design avec Material Design Lite
 */
import Vuetify from 'vuetify'
import 'vuetify/dist/vuetify.min.css'

/**
 * Module gérant la scrollbar
 */
import Vuebar from 'vuebar'

/**
 * Module pour la traduction de l'application
 */
import i18n from './translation'

/**
 * Module pour la validation des formulaires
 */
import validator from './validator'

/**
 * Module pour l'utilisation des cookies
 */
import cookie from 'vue-cookie'

/**
 * Module des filtres de l'application
 */
import filters from './filters'

/**
 * Modules pour les graphiques
 */
import VueHighcharts from 'vue-highcharts'
import Highcharts from 'highcharts'
import loadExporting from 'highcharts/modules/exporting'
import highchartsMore from 'highcharts/highcharts-more'
import solidGauge from 'highcharts/modules/solid-gauge'
import xrange from 'highcharts/modules/xrange-series'

/**
 *  Composants VueJS
 *  - ajax : sert aux requêtes Ajax mais aussi à utilisation d'interceptors (abort de Ajax, loading lors des Ajax...)
 *  - router : sert pour le routing et l'affichage des vues, chargement asynchrone de composant...
 *  - store : sert à stocker le state général de l'application, comme le fait que le l'utilisateur soit loggué ou non
 */
import axios from './ajax'
import { sync } from 'vuex-router-sync'
import store from './store'
import router from './router'

/**
 * Module vers l'API TF
 */
import tfApi from 'tfapi-client'

/**
 *  Point d'entrée de l'application
 */
import App from './App'

/**
 *  Composants Watcheezy
 */
import WzAvatar from './components/watcheezy/WzAvatar'
import WzAvatarDouble from './components/watcheezy/WzAvatarDouble'
import WzMenu from './components/watcheezy/WzMenu'
import WzAgentStatus from './components/watcheezy/WzAgentStatus'
import WzPupitreStatus from './components/watcheezy/WzPupitreStatus'
import WzNotifications from './components/watcheezy/WzNotifications' // système de notifications (arrivée des messages...)
import WzAgentMenu from './components/watcheezy/WzAgentMenu' // menu perso de l'agent (modif, log out...)
import WzSwitchLang from './components/watcheezy/WzSwitchLang'
import WzBiblio from './components/watcheezy/WzBiblio'
import WzSentence from './components/watcheezy/WzSentence'
import WzHistoChats from './components/watcheezy/WzHistoChats'
import WzHistoBot from './components/watcheezy/WzHistoBot'
import WzFileSelector from './components/watcheezy/WzFileSelector'
import WzImgUpload from './components/watcheezy/WzImgUpload'
import WzSelectAgents from './components/watcheezy/WzSelectAgents'
import WzSelectBots from './components/watcheezy/WzSelectBots'
import WzSelectMotifs from './components/watcheezy/WzSelectMotifs'
import WzSelectOneAgent from './components/watcheezy/WzSelectOneAgent'
import WzSelectOneSite from './components/watcheezy/WzSelectOneSite'
import WzSelectGender from './components/watcheezy/WzSelectGender'
import WzRating from './components/watcheezy/WzRating'
import WzHelp from './components/watcheezy/WzHelp'
import WzSatisfactionAgent from './components/watcheezy/WzSatisfactionAgent'
import WzNotifier from './components/watcheezy/WzNotifier'
import WzDialog from './components/watcheezy/WzDialog'
import WzEditeurLead from './components/watcheezy/WzEditeurLead'
import WzAgentsOccupationDay from './components/watcheezy/WzAgentsOccupationDay'
import WzAgentsOccupationPeriode from './components/watcheezy/WzAgentsOccupationPeriode'
import WzAgentsPresenceDay from './components/watcheezy/WzAgentsPresenceDay'

// Composant pour le chat watcheebox et cobrowsing
import WzWatcheeboxVisiteur from './components/watcheebox/WzWatcheeboxVisiteur'
import WzWatcheeboxAgent from './components/watcheebox/WzWatcheeboxAgent'
import WzListAgents from './components/watcheebox/WzListAgents'
import WzCobrowsingClient from './components/watcheebox/WzCobrowsingClient'
import WzFenetreChat from './components/watcheebox/WzFenetreChat'
import WzViewChat from './components/watcheebox/WzViewChat'
import WzViewAttente from './components/watcheebox/WzViewAttente'
import WzVisiteurAttente from './components/watcheebox/WzVisiteurAttente'
import WzVisiteurTimer from './components/watcheebox/WzVisiteurTimer'
import WzContentInfosVisiteur from './components/watcheebox/WzContentInfosVisiteur'
import WzFicheInfosVisiteur from './components/watcheebox/WzFicheInfosVisiteur'
import WzFicheBiblioPhrases from './components/watcheebox/WzFicheBiblioPhrases'
import WzFicheLeadVisiteur from './components/watcheebox/WzFicheLeadVisiteur'
import WzListChatsAgent from './components/watcheebox/WzListChatsAgent'

// Composant pour les DialogBox
import WzDialogCloseChat from './components/watcheebox/WzDialogCloseChat'
import WzDialogTransfertChat from './components/watcheebox/WzDialogTransfertChat'
import WzDialogBannishVisitor from './components/watcheebox/WzDialogBannishVisitor'
import WzDialogInfos from './components/watcheebox/WzDialogInfos'
import WzDialogProgress from './components/watcheebox/WzDialogProgress'

/**
 * Mixins
 */
import permissions from './mixins/permissions'

/**
 * Import dropzone
 */
import vue2Dropzone from 'vue2-dropzone'
// import 'vue2-dropzone/dist/vue2Dropzone.min.css'
import './assets/css/vue2Dropzone.css'
Vue.component('vue-dropzone', vue2Dropzone) // composant dropzone

/**
 * Utilisation de Vuetify par VueJS
 */
Vue.use(Vuetify, {
  theme: {
    primary: '#1961AC', // couleur DRDE
    secondary: '#E74011', // couleur DRDE
    accent: '#5BC5F2',
    tertiary: '#BDBDBD',
    info: '#2196F3', // $blue.base
    warning: '#FFC107', // $amber.base
    error: '#F44336', // $red.base
    success: '#4CAF50' // $green.base
  }
})
/*
const opts = {}

export default new Vuetify(opts)
*/
/**
 * Utilisation de la scrollbar
 */
Vue.use(Vuebar)

/**
 * Utilisation du module graphique
 */
loadExporting(Highcharts)
highchartsMore(Highcharts)
xrange(Highcharts)
solidGauge(Highcharts)
Vue.use(VueHighcharts, { Highcharts })

/**
 * Utilisation des composants par Vue
 */
Vue.component('wz-avatar', WzAvatar)
Vue.component('wz-avatar-double', WzAvatarDouble)
Vue.component('wz-menu', WzMenu)
Vue.component('wz-agent-status', WzAgentStatus)
Vue.component('wz-pupitre-status', WzPupitreStatus)
Vue.component('wz-notifications', WzNotifications)
Vue.component('wz-agent-menu', WzAgentMenu)
Vue.component('wz-switch-lang', WzSwitchLang)
Vue.component('wz-biblio', WzBiblio)
Vue.component('wz-sentence', WzSentence)
Vue.component('wz-histo-chats', WzHistoChats)
Vue.component('wz-histo-bot', WzHistoBot)
Vue.component('wz-file-selector', WzFileSelector)
Vue.component('wz-img-upload', WzImgUpload)
Vue.component('wz-select-agents', WzSelectAgents)
Vue.component('wz-select-bots', WzSelectBots)
Vue.component('wz-select-motifs', WzSelectMotifs)
Vue.component('wz-select-one-agent', WzSelectOneAgent)
Vue.component('wz-select-one-site', WzSelectOneSite)
Vue.component('wz-select-gender', WzSelectGender)
Vue.component('wz-rating', WzRating)
Vue.component('wz-help', WzHelp)
Vue.component('wz-satisfaction-agent', WzSatisfactionAgent)
Vue.component('wz-notifier', WzNotifier)
Vue.component('wz-dialog', WzDialog)
Vue.component('wz-editeur-lead', WzEditeurLead)
Vue.component('wz-agents-occupation-day', WzAgentsOccupationDay)
Vue.component('wz-agents-occupation-periode', WzAgentsOccupationPeriode)
Vue.component('wz-agents-presence-day', WzAgentsPresenceDay)
Vue.component('wz-editeur-lead', WzEditeurLead)

/**
 * Utilisation des composants chat Watcheebox par Vue
 */
Vue.component('wz-watcheebox-visiteur', WzWatcheeboxVisiteur) // le visiteur
Vue.component('wz-watcheebox-agent', WzWatcheeboxAgent) // l'agent
Vue.component('wz-list-agents', WzListAgents) // la liste d'agent
Vue.component('wz-cobrowsing-client', WzCobrowsingClient) // la vu mirroring du visiteur
Vue.component('wz-fenetre-chat', WzFenetreChat) // la fenetre de chat
Vue.component('wz-view-chat', WzViewChat) // la vue visiteur avec chat cobrowsing etc....
Vue.component('wz-view-attente', WzViewAttente) // la vue file d'attente
Vue.component('wz-visiteur-attente', WzVisiteurAttente) // le visiteur dans la file d'attente
Vue.component('wz-visiteur-timer', WzVisiteurTimer) // le timer visiteur attente
Vue.component('wz-content-infos-visiteur', WzContentInfosVisiteur) // le contenu des infos visiteur
Vue.component('wz-fiche-infos-visiteur', WzFicheInfosVisiteur) // la fiche des infos visiteur
Vue.component('wz-fiche-biblio-phrases', WzFicheBiblioPhrases) // la fiche des phrases agent
Vue.component('wz-fiche-lead-visiteur', WzFicheLeadVisiteur) // la fiche du lead visiteur
Vue.component('wz-list-chats-agent', WzListChatsAgent) // la liste des chats de l'agent selectionné

Vue.component('wz-dialog-transfert-chat', WzDialogTransfertChat) // permet de transférer un chat vers un autre agent
Vue.component('wz-dialog-bannish-visitor', WzDialogBannishVisitor) // permet de bannir un visiteur
Vue.component('wz-dialog-close-chat', WzDialogCloseChat) // la liste des chats de l'agent selectionné
Vue.component('wz-dialog-infos', WzDialogInfos) // ouvre une dialogBox pour afficher des infos type infobull
Vue.component('wz-dialog-progress', WzDialogProgress) // ouvre une dialogBox pour afficher des infos type infobull

/**
 * Filtres
 */
for (const filter in filters) {
  if (filters.hasOwnProperty(filter)) {
    Vue.filter(filter, filters[filter])
  }
}

/**
 * Mixins
 */
Vue.mixin(permissions)

/**
 * Synchronisation entre le store et le router
 */
sync(store, router)

Vue.config.productionTip = false
/* eslint-disable no-new */
new Vue({
  el: '#app',
  axios,
  router,
  store,
  i18n,
  cookie,
  validator,
  template: '<App/>',
  created () {
    tfApi.init({
      env: process.env.NODE_ENV
    })
  },
  components: { App }
})



// WEBPACK FOOTER //
// ./src/main.js